import { Component } from 'react';
import withMessages from 'component-utilities/intl';
import displayName from 'component-lib/displayName';
import { stateLogic, viewLogic, viewContents } from './ExportDeconstructed';

@withMessages
@stateLogic
export default class ExportDropdown extends Component {
    static displayName = displayName('Dropdowns/ExportDropdown');

    render() {
        return viewContents({ ...this.props, ...viewLogic(this.props) });
    }
}
